import React from 'react';

import Link from '@atlaskit/link/link';

export default function Default(): React.JSX.Element {
	return <Link href="https://www.atlassian.com/software/jira">Default link</Link>;
}
